module.exports = __webpack_public_path__ + "static/media/138-bahrain.85ae3d69.svg";